<script setup lang="ts">
import FormCategoria from '../components/form-categoria.vue'
import { useCategoriaStore } from '../store/useCategoriaStore'

definePage({
  meta: {
    action: 'create',
    subject: 'categoria',
    navActiveLink: 'admin-categoria-fornecedor',
  },
})

const { resetForm } = useCategoriaStore()

onBeforeRouteLeave(() => {
  resetForm()
})
</script>

<template>
  <FormCategoria />
</template>
